import React from 'react';
import { useNavigate } from 'react-router-dom';
import studentVideo from '../../assets/videos/student.mp4';
import Button from '../Button/Button';
import './StudentPrograms.css';

const StudentPrograms = () => {
  const navigate = useNavigate();

  const handleSearchCollege = () => {
    navigate('/college-finder');
  };

  const handleSearchExperts = () => {
    navigate('/counsellor');
  };
  const handleEducationLoans = () => {
    navigate('/education-loan');
  };

  return (
    <section className="student-programs-section">
      {/* Video Background */}
      <video
        className="video-background"
        src={studentVideo}
        autoPlay
        loop
        muted
        playsInline
      />

      {/* Overlays */}
      <div className="student-overlay"></div>

      {/* Content */}
      <div className="student-content">
        
        {/* Headings */}
        <div className="student-headings">
          <h3>Specially curated programs</h3>
          <h2>Only For Students</h2>
        </div>

        {/* Cards Container */}
        <div className="cards-grid">
          
          {/* Card 1 */}
          <ProgramCard 
            title="Find the" 
            highlight="Right College" 
            suffix="for you career."
            description="Find the best suitable college over 50,000+ colleges in India."
            buttonText="SEARCH COLLEGE"
            onClick={handleSearchCollege}
          />

          {/* Card 2 */}
          <ProgramCard 
            title="Find the" 
            highlight="Right Counselor" 
            suffix="for you career."
            description="Find the best career guidance and mentorship from experts."
            buttonText="SEARCH EXPERTS"
            onClick={handleSearchExperts}
          />

          {/* Card 3 */}
          <ProgramCard 
            title="Find the" 
            highlight="Best Education Loans" 
            suffix="for you."
            description="We provide access to the best education loans with low interest rate."
            buttonText="SEARCH & APPLY"
            onClick={handleEducationLoans}
          />

        </div>
      </div>
    </section>
  );
};

const ProgramCard = ({ title, highlight, suffix, description, buttonText, onClick }) => {
  return (
    <div className="program-card">
      <div>
        <h3>
          {title} <span className="highlight-text">{highlight}</span> {suffix}
        </h3>
        <p>
          {description}
        </p>
      </div>
      
      <Button variant="primary" showArrow={true} onClick={onClick}>
        {buttonText}
      </Button>
    </div>
  );
};

export default StudentPrograms;
